export default __webpack_public_path__ + "static/media/docker.3870d803.png";